import { IPuzzleData, CellState, ClueType, CellType, IClue, ICell, PuzzleType, FeedFormat } from 'js/crossword/types';

// crossword info
export default function convertREACH(rawData: any): IPuzzleData {
  const crossWordData = rawData.data;
  const metaData = rawData.metaData;

  const columns = Number(crossWordData.crossword[0].grid[0].$.width);
  const rows = Number(crossWordData.crossword[0].grid[0].$.width);

  const cells: ICell[] = crossWordData.crossword[0].grid[0].cell.map(converCell).sort((a, b) => {
    return (a.x + (a.y * 100)) - (b.x + (b.y * 100));
  });

  const clues: IClue[] = crossWordData.crossword[0].clues.map((clues: any) => {
    const type = clues.title[0].b[0] === 'Across' ? ClueType.Across : ClueType.Down;
    return clues.clue.map((clueRaw) => convertClue(crossWordData, clueRaw, type));
  }).flat();

  return {
    type: PuzzleType.Regular,
    id: metaData.id,
    metaData: {
      title: metaData.title,
      author: metaData.author,
      date: metaData.date,
      format: FeedFormat.REACH,
    },
    columns,
    rows,
    clues,
    cells,
  };
}

function converCell(cellRaw: any): ICell {
  const cellData = cellRaw.$;
  return {
    id: getCellIdForPosition(cellData.x, cellData.y),
    type: cellData.type === 'block' ? CellType.Empty : CellType.Regular,
    letter: '',
    state: CellState.Normal,
    number: cellData.number ? parseInt(cellData.number, 10) : null,
    x: parseInt(cellData.x, 10) - 1,
    y: parseInt(cellData.y, 10) - 1,
    solution: cellData.solution || "",
    circle: false,
  };
}

function getRawCell(data: any, x: string, y: string): any {
  return data.crossword[0].grid[0].cell.find((cellRaw: any) => {
    return cellRaw.$.x === x && cellRaw.$.y === y;
  });
}

function convertClue(data: any, clueRaw: any, type: ClueType): IClue {
  const word = data.crossword[0].word.find((wordRaw) => {
    return wordRaw.$.id === clueRaw.$.word;
  });
  const cellsPositions = getCellPositionsForWord(word);

  return {
    id: clueRaw._,
    number: parseInt(clueRaw.$.number, 10),
    type,
    text: `${clueRaw._} (${clueRaw.$.format})`,
    cells: cellsPositions.map(([x, y]) => getCellIdForPosition(x, y)),
  };
}


function getCellIdForPosition(x: string, y: string): string {
  return `${x}-${y}`;
}

function getCellPositionsForWord(wordRaw: any): Array<[string, string]> {
  const wordData = wordRaw.$;

  const positions: Array<[string, string]> = [];

  if (wordData.x.includes('-')) {
    const xRange = wordData.x.split('-').map(Number);
    for (let x = xRange[0]; x <= xRange[1]; x++) {
      positions.push([x.toString(), wordData.y]);
    }
  } else {
    const yRange = wordData.y.split('-').map(Number);
    for (let y = yRange[0]; y <= yRange[1]; y++) {
      positions.push([wordData.x, y.toString()]);
    }
  }

  return positions;
}
